import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createPartnerProductService: '/product/partner',
  updateManyProduct: '/product/partner/updateMany',
  getPartnerProductDetails: '/product/partner/productId',
  getAllPartnerProduct: '/product/partner/getAll',
  getFilterPartnerProduct: '/product/partner/filter',
  uploadPartnerProductImages: '/product/partner/uploadImages',
  updatePartnerProduct: '/product/partner/update',
  updatePartnerProductStatus: '/product/partner/updateStatus',
  deletePartnerProduct: 'product/partner/delete'
};

export const createPartnerProductServiceApi = createAsyncThunk(
  'serviceplug/createPartnerProductServiceApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.createPartnerProductService}`,
        method: 'post',
        data: params
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const updateManyProductApi = createAsyncThunk('serviceplug/updateManyProductApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateManyProduct}`,
      method: 'post',
      data: params
    });
    const data = await response.data;
    return data?.result;
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const deletePartnerProductApi = createAsyncThunk(
  'serviceplug/deletePartnerProductApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.deletePartnerProduct}/${params.partnerProductId}`,
        method: 'delete'
      });
      const data = await response.data;
      return data?.result;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getPartnerProductDetailsApi = createAsyncThunk(
  'serviceplug/getPartnerProductDetailsApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(`${urls.getPartnerProductDetails}`, { params });

      // const response = await axios.get(`${urls.getPartnerProductDetails}/${params.productId}`);
      if (!_.isEmpty(response.data?.result)) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getAllPartnerProductApi = createAsyncThunk(
  'serviceplug/getAllPartnerProductApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.get(urls.getAllPartnerProduct, { params });
      if (response.data?.result) {
        return response.data?.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getFilterPartnerProductApi = createAsyncThunk(
  'serviceplug/getFilterPartnerProductApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.getFilterPartnerProduct}`,
        method: 'post',
        data: params
      });
      const data = await response.data;
      return data?.result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const uploadPartnerProductImagesApi = createAsyncThunk(
  'user/uploadPartnerProductImagesApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.uploadPartnerProductImages}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const updatePartnerProductApi = createAsyncThunk('serviceplug/updateProduct', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updatePartnerProduct}/${params._id}`,
      method: 'put',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updatePartnerProductStatusApi = createAsyncThunk(
  'serviceplug/updatePartnerProductStatus',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.updatePartnerProductStatus}`,
        method: 'post',
        data: params
      });
      const data = await response.data?.result;
      return data;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);
